import { object, string } from "yup";

import Postcode from "./steps/Postcode";
import AddressSelect from "./steps/AddressSelect";
import Results from "./steps/Results";

export default [
  {
    id: "postcode",
    component: Postcode,
    initialValues: {
      postcode: ""
    },
    validationSchema: object().shape({
      postcode: string().required()
    })
  },
  {
    id: "address",
    component: AddressSelect,
    initialValues: {
      addressSelect: ""
    },
    validationSchema: object().shape({
      addressSelect: string().required()
    }),
    actionLabel: "Proceed",
  },
  {
    id: "summary",
    component: Results
  }
];
